// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PartConfigModelType } from './part-config-model-type';
import { PartConfigSizeLink } from './part-config-size-link';
import { PartConfigWinchStand } from './part-config-winch-stand';
import { PartConfigWinchStandOption } from './part-config-winch-stand-option';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags
class LinkObject {
    entityId: number;
    sizeLinkId: number;
    name: string;
    isDefault?: boolean;
    priceIncrease?: number;
}
/// </module-code>

export class PartConfigModelSize extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  _axleSizes: LinkObject[];
    get axleHtml(): string {
        return this._axleSizes.map((x) => x.name).join('<br/>');
    }

    _tireSizes: LinkObject[];
    get tireHtml(): string {
        if (!this.partConfigModelType.hasSuspension) return this._tireSizes.map((x) => `${x.name}${x.isDefault ? ' ★' : ''}`).join('<br/>');
        else return '';
    }
    _suspensions: LinkObject[];
    get suspensionHtml(): string {
        return this._suspensions.map((x) => `${x.name}${x.isDefault ? ' ★' : ''}`).join('<br/>');
    }
    _options: LinkObject[];
    get optionHtml(): string {
        return this._options.map((x) => `${x.name}${x.isDefault ? ' ★' : ''}`).join('<br/>');
    }
    _winchStands: LinkObject[];
    get winchStandHtml(): string {
        return this._winchStands.map((x) => `${x.name}${x.isDefault ? ' ★' : ''}`).join('<br/>');
    }
    _placeQuantities: LinkObject[];
    get placeQtyHtml(): string {
        return this._placeQuantities.map((x) => `${x.name}`).join('<br/>');
    }

    _brakes: LinkObject[];
    get brakeHtml(): string {
        return this._brakes.map((x) => x.name).join('<br/>');
    }

    _salesAddons: LinkObject[];
    get salesAddonHtml(): string {
        return this._salesAddons?.map((x) => x.name).join('<br/>') ?? '';
    }

    setSizeLinks(links: PartConfigSizeLink[], axles: any[], tires: any[], suspensions: any[], options: any[], winchStands: any[], partConfigPlaceQuantities: any[], brakes: any[] = []) {
        const createMap = (arr: any[]) => new Map(arr.map((i) => [i.id, i]));
        const entityMaps = {
            PartConfigAxle: createMap(axles),
            PartConfigTire: createMap(tires),
            PartConfigSuspension: createMap(suspensions),
            PartConfigOption: createMap(options),
            PartConfigWinchStand: createMap(winchStands),
            PartConfigPlaceQuantities: createMap(partConfigPlaceQuantities),
            PartConfigBrake: createMap(brakes),
        };
        const mapLinks = (typeName: keyof typeof entityMaps, appendDefault = true) => {
            const lookup = entityMaps[typeName];
            return links
                .filter((link) => link.entityTypeName === typeName && !link.deleted && lookup.has(link.primaryKey))
                .map((link) => {
                    const entity = lookup.get(link.primaryKey);
                    const nameSuffix = appendDefault && link.isDefault ? ' (Default)' : '';
                    const result: any = {
                        entityId: link.primaryKey,
                        sizeLinkId: link.id,
                        name: `${entity.name}${nameSuffix}`,
                        isDefault: link.isDefault,
                        priceIncrease: link.priceIncrease,
                    };
                    if (typeName === 'PartConfigWinchStand') {
                        result._options = entity._options;
                    }
                    return result;
                });
        };
        this._axleSizes = mapLinks('PartConfigAxle', false);
        this._tireSizes = mapLinks('PartConfigTire');
        this._suspensions = mapLinks('PartConfigSuspension');
        this._options = mapLinks('PartConfigOption');
        this._winchStands = mapLinks('PartConfigWinchStand');
        this._placeQuantities = mapLinks('PartConfigPlaceQuantities', false);
        this._brakes = mapLinks('PartConfigBrake', false);
        this._salesAddons = [];
    }

    get displayName() {
        return this.description ? `${this.name} (${this.description})` : this.name;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  basePrice?: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  description?: string;
  displayOrder?: number;
  hasTorsion!: boolean;
  name?: string;
  noAxles!: boolean;
  noBrakeOption!: boolean;
  noOptions!: boolean;
  noPolyCarpetOption!: boolean;
  noSuspension!: boolean;
  noTailOption!: boolean;
  noToonOption!: boolean;
  noTreeOptions!: boolean;
  noWinchStand!: boolean;
  partConfigModelTypeId!: number;
  standardWinchStandId?: number;
  standardWinchStandOptionId?: number;
  tailYesPrice?: number;
  toonPontoonPrice?: number;
  toonTritoonPrice?: number;
  torsionPriceIncrase!: number;
  partConfigModelType!: PartConfigModelType;
  partConfigSizeLinks!: PartConfigSizeLink[];
  standardWinchStand!: PartConfigWinchStand;
  standardWinchStandOption!: PartConfigWinchStandOption;
}

